import { LoadingSpinner } from "@jugl-web/ui-components/cross-platform";
import React from "react";

export const DefaultLoadingMoreContent: React.FC = () => (
  <div className="flex justify-center py-2">
    <LoadingSpinner />
  </div>
);
